/**
 * PrithviMart custom JavaScript
 * Clean version:
 * - Keeps Buy It Now working
 * - Keeps mobile search fix working
 * - Removes old window.scrollTo override that caused mobile freeze
 * - Adds safer mobile Add to Cart / mini-cart scroll unlock fix
 */

/* =========================================================
   BUY IT NOW FUNCTIONALITY
   ========================================================= */

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-action="buy-now"]');

    if (!button) return;

    event.preventDefault();

    const productId = button.getAttribute('data-product-id');

    if (!productId) {
      console.error('Product ID not found for Buy it Now button');
      return;
    }

    const originalText = button.textContent;
    button.textContent = 'Adding...';
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: productId,
        quantity: 1,
      }),
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Cart add failed');
        }

        return response.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:refresh', {
            bubbles: true,
          })
        );

        window.location.href = '/checkout';
      })
      .catch(function (error) {
        console.error('Error adding product to cart:', error);

        button.textContent = originalText;
        button.disabled = false;

        alert('Sorry, there was an error adding the product to your cart. Please try again.');
      });
  });

  /* =========================================================
     MOBILE SEARCH DRAWER SUPPORT
     ========================================================= */

  const searchBarWrapper = document.querySelector('.header__search-bar-wrapper');
  const searchInput = document.querySelector('.search-bar__input');

  function closeSearchDrawer() {
    if (!searchBarWrapper) return;

    searchBarWrapper.classList.remove('is-fixed');

    const searchBar = searchBarWrapper.querySelector('.search-bar');
    if (searchBar) {
      searchBar.classList.remove('is-expanded');
      searchBar.classList.remove('is-loading');
    }

    if (searchInput) {
      searchInput.blur();
    }

    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('no-mobile-scroll');

    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.position = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    const searchResults = searchBarWrapper.querySelector('.search-bar__results');
    if (searchResults) {
      searchResults.setAttribute('aria-hidden', 'true');
    }

    const searchMenu = searchBarWrapper.querySelector('.search-bar__menu-wrapper');
    if (searchMenu) {
      searchMenu.setAttribute('aria-hidden', 'true');
    }
  }

  if (searchBarWrapper) {
    let isScrollingInsideDrawer = false;

    const searchInner = searchBarWrapper.querySelector('.search-bar__inner');
    const searchResults = searchBarWrapper.querySelector('.search-bar__results');

    if (searchInner) {
      searchInner.addEventListener(
        'scroll',
        function () {
          isScrollingInsideDrawer = true;
          setTimeout(function () {
            isScrollingInsideDrawer = false;
          }, 100);
        },
        { passive: true }
      );
    }

    if (searchResults) {
      searchResults.addEventListener(
        'scroll',
        function () {
          isScrollingInsideDrawer = true;
          setTimeout(function () {
            isScrollingInsideDrawer = false;
          }, 100);
        },
        { passive: true }
      );
    }

    window.addEventListener(
      'scroll',
      function () {
        if (searchBarWrapper.classList.contains('is-fixed') && !isScrollingInsideDrawer) {
          closeSearchDrawer();
        }
      },
      { passive: true }
    );

    const clearButton = document.querySelector('.search-bar__input-clear');
    if (clearButton) {
      clearButton.addEventListener('click', function () {
        setTimeout(function () {
          closeSearchDrawer();
        }, 50);
      });
    }
  }

  /* =========================================================
     CART COUNT UPDATE
     ========================================================= */

  function updateAllCartCounts() {
    return fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        const headerCartCount = document.querySelector('.header__cart-count');
        if (headerCartCount) {
          headerCartCount.textContent = cart.item_count;
        }

        const mobileCartCount = document.getElementById('mobile-cart-count');
        if (mobileCartCount) {
          mobileCartCount.textContent = cart.item_count;
        }

        const allCartCounts = document.querySelectorAll('.cart-count');
        allCartCounts.forEach(function (element) {
          if (element.id !== 'mobile-cart-count') {
            element.textContent = cart.item_count;
          }
        });

        return cart;
      })
      .catch(function (error) {
        console.error('Error updating cart count:', error);
      });
  }

  document.addEventListener('cart:refresh', function () {
    updateAllCartCounts();
  });

  /* =========================================================
     CART PAGE MILESTONE PROGRESS BAR
     ========================================================= */

  function animateProgressBar() {
    const progressFill = document.querySelector('.cart__milestone-progress-fill');

    if (!progressFill) return;

    const inlineWidth = progressFill.getAttribute('style')
      ? progressFill.getAttribute('style').match(/width:\s*([\d.]+)%/)
      : null;

    const targetWidth = progressFill.getAttribute('data-width') || (inlineWidth ? inlineWidth[1] : null);

    if (!targetWidth) return;

    progressFill.style.width = '0%';
    progressFill.style.transition = 'none';

    progressFill.offsetHeight;

    requestAnimationFrame(function () {
      progressFill.style.transition = 'width 1s cubic-bezier(0.4, 0, 0.2, 1)';

      requestAnimationFrame(function () {
        progressFill.style.width = targetWidth + '%';
      });
    });
  }

  if (window.theme && theme.pageType === 'cart') {
    setTimeout(animateProgressBar, 50);
  }
});

/* =========================================================
   PRITHVIMART CLEAN MOBILE SEARCH FIX
   Fixes green bar overlap + unlocks scroll after close
   ========================================================= */

(function () {
  function pmIsMobile() {
    return window.matchMedia('(max-width: 640px)').matches;
  }

  function pmGetSearchWrapper() {
    return document.querySelector('.header__search-bar-wrapper');
  }

  function pmGetSearchInput() {
    return document.querySelector('.search-bar__input, input[name="q"]');
  }

  function pmHideGreenBar() {
    if (!pmIsMobile()) return;

    document.body.classList.add('pm-mobile-search-active');

    document.querySelectorAll('.pm-announcement-bar').forEach(function (bar) {
      bar.style.setProperty('display', 'none', 'important');
      bar.style.setProperty('visibility', 'hidden', 'important');
      bar.style.setProperty('height', '0', 'important');
      bar.style.setProperty('overflow', 'hidden', 'important');
      bar.style.setProperty('pointer-events', 'none', 'important');
    });
  }

  function pmShowGreenBar() {
    document.body.classList.remove('pm-mobile-search-active');

    document.querySelectorAll('.pm-announcement-bar').forEach(function (bar) {
      bar.style.removeProperty('display');
      bar.style.removeProperty('visibility');
      bar.style.removeProperty('height');
      bar.style.removeProperty('overflow');
      bar.style.removeProperty('pointer-events');
    });
  }

  function pmUnlockScroll() {
    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('no-mobile-scroll');

    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.position = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
  }

  function pmOpenSearchMode() {
    if (!pmIsMobile()) return;
    pmHideGreenBar();
  }

  function pmCloseSearchMode() {
    const searchWrapper = pmGetSearchWrapper();
    const searchInput = pmGetSearchInput();
    const searchBar = document.querySelector('.search-bar');
    const searchResults = document.querySelector('.search-bar__results');
    const searchMenu = document.querySelector('.search-bar__menu-wrapper');

    if (searchInput) {
      searchInput.blur();
    }

    if (searchWrapper) {
      searchWrapper.classList.remove('is-fixed');
      searchWrapper.classList.add('is-visible');
    }

    if (searchBar) {
      searchBar.classList.remove('is-expanded');
      searchBar.classList.remove('is-loading');
    }

    if (searchResults) {
      searchResults.setAttribute('aria-hidden', 'true');
    }

    if (searchMenu) {
      searchMenu.setAttribute('aria-hidden', 'true');
    }

    pmUnlockScroll();
    pmShowGreenBar();

    setTimeout(pmUnlockScroll, 100);
    setTimeout(pmUnlockScroll, 300);
    setTimeout(pmShowGreenBar, 300);
  }

  document.addEventListener(
    'focusin',
    function (event) {
      if (event.target.matches('.search-bar__input, input[name="q"]')) {
        setTimeout(pmOpenSearchMode, 50);
        setTimeout(pmOpenSearchMode, 150);
      }
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      const clickedClear =
        event.target.closest('[data-action="clear-input"]') ||
        event.target.closest('.search-bar__input-clear');

      const clickedClose =
        event.target.closest('[data-action="unfix-search"]') ||
        event.target.closest('.search-bar__close-button');

      if (clickedClear || clickedClose) {
        setTimeout(pmCloseSearchMode, 80);
      }
    },
    true
  );

  document.addEventListener(
    'touchend',
    function (event) {
      const touchedClear =
        event.target.closest('[data-action="clear-input"]') ||
        event.target.closest('.search-bar__input-clear');

      const touchedClose =
        event.target.closest('[data-action="unfix-search"]') ||
        event.target.closest('.search-bar__close-button');

      if (touchedClear || touchedClose) {
        setTimeout(pmCloseSearchMode, 80);
      }
    },
    true
  );

  const searchWrapper = pmGetSearchWrapper();

  if (searchWrapper) {
    const observer = new MutationObserver(function () {
      if (searchWrapper.classList.contains('is-fixed')) {
        pmOpenSearchMode();
      }
    });

    observer.observe(searchWrapper, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  window.addEventListener('pageshow', function () {
    pmUnlockScroll();

    const searchWrapper = pmGetSearchWrapper();
    if (!searchWrapper || !searchWrapper.classList.contains('is-fixed')) {
      pmShowGreenBar();
    }
  });
})();

/* =========================================================
   PRITHVIMART MOBILE ADD TO CART FREEZE FIX
   Fixes frozen scroll/swipe after Add to Cart on mobile
   ========================================================= */

(function () {
  let lastAddToCartIntent = 0;

  function pmIsMobileCartFixEnabled() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  function pmMarkAddToCartIntent() {
    lastAddToCartIntent = Date.now();
  }

  function pmHadRecentAddToCartIntent() {
    return Date.now() - lastAddToCartIntent < 3500;
  }

  function pmUnlockMobileScroll() {
    document.documentElement.classList.remove('is-locked');
    document.body.classList.remove('no-mobile-scroll');

    document.documentElement.style.overflow = '';
    document.documentElement.style.height = '';
    document.documentElement.style.position = '';
    document.documentElement.style.top = '';

    document.body.style.overflow = '';
    document.body.style.height = '';
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';

    document.querySelectorAll('.is-locked, .no-mobile-scroll').forEach(function (el) {
      if (el !== document.documentElement && el !== document.body) {
        el.classList.remove('is-locked');
        el.classList.remove('no-mobile-scroll');
      }
    });
  }

  function pmCloseMiniCartOnMobile() {
    if (!pmIsMobileCartFixEnabled()) return;

    const miniCartSelectors = [
      '#mini-cart',
      '.mini-cart',
      '.cart-drawer',
      '.drawer--cart',
      '[data-section-type="mini-cart"]',
      '[aria-labelledby="mini-cart"]',
    ];

    document.querySelectorAll(miniCartSelectors.join(',')).forEach(function (miniCart) {
      miniCart.setAttribute('aria-hidden', 'true');
      miniCart.classList.remove('is-open');
      miniCart.classList.remove('is-visible');
      miniCart.classList.remove('is-expanded');
      miniCart.style.maxHeight = '';
      miniCart.style.height = '';
      miniCart.style.overflow = '';
      miniCart.style.pointerEvents = '';
    });

    document
      .querySelectorAll('[data-action="toggle-mini-cart"], .header__cart-toggle, .header__cart-icon')
      .forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', 'false');
      });

    document
      .querySelectorAll('.drawer__overlay, .modal__overlay, .page-overlay')
      .forEach(function (overlay) {
        overlay.classList.remove('is-visible');
        overlay.setAttribute('aria-hidden', 'true');
        overlay.style.pointerEvents = 'none';
      });

    pmUnlockMobileScroll();
  }

  function pmUpdateCartCountsAfterAdd() {
    fetch('/cart.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document
          .querySelectorAll('.header__cart-count, .cart-count, #mobile-cart-count')
          .forEach(function (el) {
            el.textContent = cart.item_count;
          });
      })
      .catch(function (error) {
        console.error('Cart count update failed:', error);
      });
  }

  function pmFixAfterAddToCart() {
    if (!pmIsMobileCartFixEnabled()) return;

    pmUpdateCartCountsAfterAdd();

    setTimeout(pmCloseMiniCartOnMobile, 80);
    setTimeout(pmCloseMiniCartOnMobile, 250);
    setTimeout(pmCloseMiniCartOnMobile, 600);
    setTimeout(pmUnlockMobileScroll, 1000);
  }

  document.addEventListener(
    'click',
    function (event) {
      const addToCartButton = event.target.closest(
        'button[type="submit"], [data-action="add-to-cart"], .add-to-cart-btn, .product-form__add-button'
      );

      if (!addToCartButton) return;

      const form = addToCartButton.closest('form');
      const isCartAddForm = form && form.getAttribute('action') && form.getAttribute('action').indexOf('/cart/add') !== -1;

      const isKnownAddButton =
        addToCartButton.matches('[data-action="add-to-cart"], .add-to-cart-btn, .product-form__add-button') ||
        isCartAddForm;

      if (isKnownAddButton) {
        pmMarkAddToCartIntent();
        setTimeout(pmFixAfterAddToCart, 500);
        setTimeout(pmFixAfterAddToCart, 1200);
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;

      if (
        form &&
        form.matches('form') &&
        form.getAttribute('action') &&
        form.getAttribute('action').indexOf('/cart/add') !== -1
      ) {
        pmMarkAddToCartIntent();
        setTimeout(pmFixAfterAddToCart, 500);
        setTimeout(pmFixAfterAddToCart, 1200);
      }
    },
    true
  );

  document.addEventListener('product:added', function () {
    pmMarkAddToCartIntent();
    pmFixAfterAddToCart();
  });

  document.addEventListener('cart:refresh', function () {
    if (pmHadRecentAddToCartIntent()) {
      pmFixAfterAddToCart();
    }
  });

  window.addEventListener('pageshow', function () {
    if (pmIsMobileCartFixEnabled()) {
      pmUnlockMobileScroll();
    }
  });
})();
